import { render, staticRenderFns } from "./Amount.vue?vue&type=template&id=e2f60352&scoped=true"
import script from "./Amount.vue?vue&type=script&lang=js"
export * from "./Amount.vue?vue&type=script&lang=js"
import style0 from "./Amount.vue?vue&type=style&index=0&id=e2f60352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f60352",
  null
  
)

export default component.exports